import { TableConfig } from '@shared/models/table-config.model';
import { ProductName } from '@core/constants';

export default {
  [ProductName.DMEPOS_MA]: [
    {
      name: 'User',
      dataKey: 'user',
      frozen: true,
      styles: {
        width: '15%',
        minWidth: '220px',
      },
      headerStyles: {
        width: '15%',
        minWidth: '220px',
      },
      filterOptions: {
        template: 'user',
        propName: 'userId',
        filterEnabled: true,
      },
    },
    {
      name: 'Second Level',
      dataKey: 'secondLevelReview',
      styles: {
        width: '9.5%',
        minWidth: '135px',
      },
      headerStyles: {
        width: '9.5%',
        minWidth: '135px',
      },
      filterOptions: {
        template: 'multiselect',
        propName: 'secondLevelReview',
        filterEnabled: true,
      },
    },
    {
      name: 'Specialty',
      dataKey: 'specialty',
      styles: {
        width: '7%',
        minWidth: '105px',
      },
      headerStyles: {
        width: '7%',
        minWidth: '105px',
      },
      filterOptions: {
        template: 'multiselect',
        propName: 'specialty',
        filterEnabled: true,
      },
    },
    {
      name: 'State',
      dataKey: 'states',
      styles: {
        width: '6.5%',
        minWidth: '0',
      },
      headerStyles: {
        width: '6.5%',
        minWidth: '0',
      },
      referenceKey: 'postalState',
      filterOptions: {
        template: 'multiselect',
        filterByProp: 'states',
        propName: 'postalState',
        filterEnabled: true,
      },
    },
    {
      name: 'Case Category',
      dataKey: 'categories',
      styles: {
        width: '10%',
        minWidth: '140px',
      },
      headerStyles: {
        width: '10%',
        minWidth: '140px',
      },
      referenceKey: 'caseCategory',
      filterOptions: {
        template: 'multiselect',
        filterByProp: 'categories',
        propName: 'caseCategory',
        filterEnabled: true,
      },
    },
    {
      name: 'Client',
      dataKey: 'tenantName',
      styles: {
        width: '10%',
        minWidth: '140px',
      },
      headerStyles: {
        width: '10%',
        minWidth: '140px',
      },
      referenceKey: 'tenant',
      filterOptions: {
        template: 'multiselect',
        filterByProp: 'tenantName',
        propName: 'tenant',
        filterEnabled: true,
      },
    },
    {
      name: 'Max Line',
      dataKey: 'totalLimit',
      styles: {
        width: '4.5%',
        minWidth: '85px',
      },
      headerStyles: {
        width: '4.5%',
        minWidth: '85px',
      },
    },
    {
      name: 'Current Lines in Queue',
      dataKey: 'totalCount',
      styles: {
        width: '6.5%',
        minWidth: '85px',
      },
      headerStyles: {
        width: '6.5%',
        minWidth: '85px',
      },
    },
    {
      name: 'On/Off',
      dataKey: 'isActive',
      styles: {
        width: '6.5%',
        minWidth: '90px',
      },
      headerStyles: {
        width: '6.5%',
        minWidth: '90px',
      },
      filterOptions: {
        template: 'select',
        propName: 'isActive',
        filterEnabled: false,
      },
    },
    {
      name: '',
      dataKey: 'delete',
      styles: {
        width: '3%',
        minWidth: '48px',
      },
      headerStyles: {
        width: '3%',
        minWidth: '48px',
      },
    },
  ] satisfies TableConfig,
  [ProductName.DMEPOS_MCD]: [
    {
      name: 'User',
      dataKey: 'user',
      frozen: true,
      styles: {
        width: '15%',
        minWidth: '220px',
      },
      headerStyles: {
        width: '15%',
        minWidth: '220px',
      },
      filterOptions: {
        template: 'user',
        propName: 'userId',
        filterEnabled: true,
      },
    },
    {
      name: 'Second Level',
      dataKey: 'secondLevelReview',
      styles: {
        width: '9.5%',
        minWidth: '135px',
      },
      headerStyles: {
        width: '9.5%',
        minWidth: '135px',
      },
      filterOptions: {
        template: 'multiselect',
        propName: 'secondLevelReview',
        filterEnabled: true,
      },
    },
    {
      name: 'Specialty',
      dataKey: 'specialty',
      styles: {
        width: '7%',
        minWidth: '105px',
      },
      headerStyles: {
        width: '7%',
        minWidth: '105px',
      },
      filterOptions: {
        template: 'multiselect',
        propName: 'specialty',
        filterEnabled: true,
      },
    },
    {
      name: 'State',
      dataKey: 'states',
      styles: {
        width: '6.5%',
        minWidth: '0',
      },
      headerStyles: {
        width: '6.5%',
        minWidth: '0',
      },
      referenceKey: 'postalState',
      filterOptions: {
        template: 'multiselect',
        filterByProp: 'states',
        propName: 'postalState',
        filterEnabled: true,
      },
    },
    {
      name: 'MCO',
      dataKey: 'mco',
      styles: {
        width: '10%',
        minWidth: '140px',
      },
      headerStyles: {
        width: '10%',
        minWidth: '140px',
      },
      referenceKey: 'mco',
      filterOptions: {
        template: 'multiselect',
        filterByProp: 'mco',
        propName: 'mco',
        filterEnabled: true,
      },
    },
    {
      name: 'Case Category',
      dataKey: 'categories',
      styles: {
        width: '10%',
        minWidth: '140px',
      },
      headerStyles: {
        width: '10%',
        minWidth: '140px',
      },
      referenceKey: 'caseCategory',
      filterOptions: {
        template: 'multiselect',
        filterByProp: 'categories',
        propName: 'caseCategory',
        filterEnabled: true,
      },
    },
    {
      name: 'Client',
      dataKey: 'tenantName',
      styles: {
        width: '10%',
        minWidth: '140px',
      },
      headerStyles: {
        width: '10%',
        minWidth: '140px',
      },
      referenceKey: 'tenant',
      filterOptions: {
        template: 'multiselect',
        filterByProp: 'tenantName',
        propName: 'tenant',
        filterEnabled: true,
      },
    },
    {
      name: 'Max Line',
      dataKey: 'totalLimit',
      styles: {
        width: '4.5%',
        minWidth: '85px',
      },
      headerStyles: {
        width: '4.5%',
        minWidth: '85px',
      },
    },
    {
      name: 'Current Lines in Queue',
      dataKey: 'totalCount',
      styles: {
        width: '6.5%',
        minWidth: '85px',
      },
      headerStyles: {
        width: '6.5%',
        minWidth: '85px',
      },
    },
    {
      name: 'On/Off',
      dataKey: 'isActive',
      styles: {
        width: '6.5%',
        minWidth: '90px',
      },
      headerStyles: {
        width: '6.5%',
        minWidth: '90px',
      },
      filterOptions: {
        template: 'select',
        propName: 'isActive',
        filterEnabled: false,
      },
    },
    {
      name: '',
      dataKey: 'delete',
      styles: {
        width: '3%',
        minWidth: '48px',
      },
      headerStyles: {
        width: '3%',
        minWidth: '48px',
      },
    },
  ] satisfies TableConfig,
};
